import React from 'react';
import { GlobalStyle } from '../styles/styles';
import NavbarComp from '../components/Navbar/components/NavbarComp';
import HeroComp from '../components/Hero/components/HeroComp';
import SkillsComp from '../components/Skills/components/SkillsComp';
import ProjectsComp from '../components/Projects/components/ProjectsComp';
import EducationComp from '../components/Education/components/EducationComp';
import CertificationsComp from '../components/Certifications/components/CertificationsComp';
import ContactComp from '../components/Contact/components/ContactComp';
import FooterComp from '../components/Footer/components/FooterComp';
import AboutMeComp from '../components/AboutMe/components/AboutMeComp';
import { useTheme } from '@mui/material/styles';
import WhatsAppButtonComp from '../components/WhatsAppButton/components/WhatsAppButtonComp';

const HomePage = () => {
  const theme = useTheme();

  return (
    <>
      <GlobalStyle theme={theme} />
      <NavbarComp />
      <HeroComp />
      <AboutMeComp />
      <SkillsComp />
      <ProjectsComp />
      <EducationComp />
      <CertificationsComp />
      <ContactComp />
      <FooterComp />
      <WhatsAppButtonComp/> 
    </>
  );
};

export default HomePage;
